module.exports = __webpack_public_path__ + "static/media/course_04.50369ecf.jpg";